import type React from 'react';
export { default as Groceries } from './groceries.svg';

export interface GikIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export const GikIconDefaultSize = 24;
